"use client";

import { Image, Text } from "@pamperedchef/design-system";
import type { TestimonialItem } from "@/composites/landing/types";
import { Rating } from "@/composites/landing/Rating";
import * as styles from "./Testimonial.module.scss";

export type TestimonialProps = TestimonialItem;

/**
 * Single testimonial card — optional rating, quote, author name + meta, and
 * an optional avatar. Presentational, props-in.
 */
export function Testimonial({
	rating,
	quote,
	author_name,
	author_meta,
	avatar
}: TestimonialProps) {
	return (
		<figure className={styles["testimonial"]} data-component="Testimonial">
			{typeof rating === "number" ? <Rating value={rating} /> : null}

			<blockquote className={styles["testimonial__quote"]}>
				<Text tag="p" styledAs="mdr">
					{quote}
				</Text>
			</blockquote>

			<figcaption className={styles["testimonial__author"]}>
				{avatar ? (
					<span className={styles["testimonial__avatar"]}>
						<Image
							src={avatar.url}
							alt={avatar.alt ?? author_name}
							aspectRatio="1:1"
							objectFit="cover"
						/>
					</span>
				) : null}
				<span className={styles["testimonial__author-text"]}>
					<span className={styles["testimonial__author-name"]}>
						{author_name}
					</span>
					{author_meta ? (
						<span className={styles["testimonial__author-meta"]}>
							{author_meta}
						</span>
					) : null}
				</span>
			</figcaption>
		</figure>
	);
}
